<!-- Breadcrumb -->
<ol class="breadcrumb">
  <li class="breadcrumb-item">
    <a routerLink="">Início</a>
  </li>
  <li class="breadcrumb-item">Minha Conta</li>
  <li class="breadcrumb-item active">
    Meus Prêmios
  </li>
</ol>
<!-- //.Breadcrumb -->
<h2 class="titulo-interna">Prêmios</h2>

<form autocomplete="off" method="POST" id="frmListarPremios" name="frmListarPremios"
 class="form-horizontal">
  <div *ngIf="semRegistros" class="alert alert-danger col-sm-12">
    {{ this.notificacao }}
  </div>
  <div class="row" *ngIf="_premios">
    <div class="col" *ngIf="_premios.length > 0">
        <table class="table table-striped" aria-describedby="Listagem Prêmios cidadão">
            <thead>
                <tr>
                  <th></th>
                  <th>Tipo do Sorteio</th>
                  <th>Sorteio</th>
                  <th>Data de Realização do Sorteio</th>
                  <th>Prêmios</th>
                </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let premio of _premios; let i = index">
                    <td>
                    </td>
                    <td>{{ premio.desTipoSorteioPremiacaoConsumidor }}</td>
                    <td>{{ premio.desSorteioPremiacaoConsumidor }}</td>
                    <td>{{ premio.dtcRealizacaoSorteiroPremiacaoConsumidor | date:'dd/MM/yyyy' }}</td>
                    <td>{{ premio.valPremioSorteioPremiacaoConsumidor | currency:'BRL':'1.1-2' }}</td>
                  </tr>
                </tbody>
        </table>

        <div class="row" *ngIf="existePremio()">
          <div class="col-12">
            <ngb-pagination
              [collectionSize]="totalPremios"
              [(page)]="pagina"
              [pageSize]="tamanho"
              [maxSize]="5"
              [rotate]="true"
              [ellipses]="false"
              [boundaryLinks]="true"
              (pageChange)="pageChange($event)"
              class="d-flex justify-content-end"></ngb-pagination>
          </div>

        </div>
    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-premios/consumidor-premios.component.html